<template>
  <div>
    <tree-grid
      :items="menuManagementData"
      :columns="columns"
      @on-row-click="rowClick"
    ></tree-grid>
    <!-- 操作日志详情 -->
    <configuration-management-operation-log
      v-if="isShowOperationLog"
      ref="configurationManagementOperationLog"
    ></configuration-management-operation-log>
    <!-- 删除 -->
    <Modal v-model="menuDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>{{ $t("alarms.common.sureDelete") }} {{ menuName }} ?</p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="removeMenu()"
          >{{ $t("common.del") }}</Button
        >
      </div>
    </Modal>
    <!-- 编辑 -->
    <Modal
      v-model="menuManagementEditModal"
      :title="$t('MenuManagement.editMenu')"
      :loading="loading"
      @on-ok="menuManagementEditSubmit('menuManagementEditForm')"
      @on-cancel="menuManagementEditReset('menuManagementEditForm')"
      :mask-closable="false"
    >
      <Form
        ref="menuManagementEditForm"
        :model="menuManagementEditForm"
        :label-width="100"
        :rules="ruleValidate"
      >
        <!-- 菜单角色 -->
        <FormItem label="菜单角色" prop="menuRole">
          <RadioGroup v-model="menuManagementEditForm.menuRole">
            <Radio
              v-for="list in menuRoleList"
              :label="list.label"
              :key="list.id"
              >{{ list.name }}</Radio
            >
          </RadioGroup>
        </FormItem>
        <!-- 公司 -->
        <FormItem label="公司" prop="companyIds">
          <Select
            v-model="menuManagementEditForm.companyIds"
            filterable
            multiple
            :placeholder="$t('alarms.common.pleaseSelectCompany')"
            :transfer="true"
            @on-change="changeCompany()"
            style="width:200px"
          >
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
              :disabled="item.disabled"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <!-- 类型 -->
        <FormItem :label="$t('MenuManagement.category')" prop="menuType">
          <RadioGroup
            v-model="menuManagementEditForm.menuType"
            @on-change="changeMenuType(menuManagementEditForm.menuType)"
          >
            <Radio
              v-for="list in menuTypeList"
              :label="list.label"
              :key="list.name"
              >{{ list.name }}</Radio
            >
          </RadioGroup>
        </FormItem>
        <!-- 上级菜单 -->
        <FormItem :label="$t('MenuManagement.upperMenu')">
          <Tree
            :data="menuData"
            @on-select-change="selectAll"
            ref="tree"
            style="height:180px;overflow-y: auto;"
            :render="renderContent"
          ></Tree>
        </FormItem>
        <div v-if="menuManagementEditForm.menuType === 'B'">
          <!-- 按钮名称 -->
          <FormItem :label="$t('MenuManagement.buttonName')" prop="buttonName">
            <Input
              v-model="menuManagementEditForm.buttonName"
              style="width:300px;"
            ></Input>
          </FormItem>
          <!-- 权限标识 -->
          <FormItem :label="$t('MenuManagement.permissionIcon')" prop="perms">
            <Input
              v-model="menuManagementEditForm.perms"
              style="width:300px;"
            ></Input>
          </FormItem>
        </div>
        <div v-else>
          <!-- 菜单标题 -->
          <FormItem :label="$t('MenuManagement.menuTitle')" prop="title">
            <Input
              v-model="menuManagementEditForm.title"
              style="width:300px;"
            ></Input>
          </FormItem>
          <!-- 英文标题 -->
          <FormItem
            :label="$t('MenuManagement.englishTitle')"
            prop="titleEnglish"
          >
            <Input
              v-model="menuManagementEditForm.titleEnglish"
              style="width:300px;"
            ></Input>
          </FormItem>
          <!-- 菜单图标 -->
          <FormItem :label="$t('MenuManagement.menuIcon')" prop="icon">
            <Input
              v-model="menuManagementEditForm.icon"
              style="width:300px;"
            ></Input>
          </FormItem>
          <!-- 排序 -->
          <FormItem :label="$t('MenuManagement.sort')" prop="order">
            <Input
              v-model="menuManagementEditForm.order"
              style="width:300px;"
            ></Input>
          </FormItem>
          <!-- 地址栏路径 -->
          <FormItem :label="$t('MenuManagement.addressPath')" prop="path">
            <Input
              v-model="menuManagementEditForm.path"
              style="width:300px;"
            ></Input>
          </FormItem>
          <!-- 组件路径 -->
          <FormItem
            :label="$t('MenuManagement.componentPath')"
            prop="component"
          >
            <Input
              v-model="menuManagementEditForm.component"
              style="width:300px;"
            ></Input>
          </FormItem>
        </div>
      </Form>
    </Modal>
  </div>
</template>
<script>
import TreeGrid from "../menu_management/TableGrid";
import ConfigurationManagementOperationLog from "../../common/ConfigurationManagementOperationLog.vue";
import { setCookie, getCookie } from "../../../../utils/cookieUtil.js";

let tableMenuManagementVue = {};
export default {
  name: "TableMenuManagement",
  components: {
    TreeGrid,
    ConfigurationManagementOperationLog
  },
  props: ["companyId"],
  watch: {
    companyId: {
      handler(newVal, oldVal) {
        this.getCompanyId = newVal;
        tableMenuManagementVue.getMenuManagementData();
      },
      deep: true,
      immediate: true
    },
    "menuManagementEditForm.companyIds"(newVal, oldVal) {
      if (newVal.includes(0)) {
        this.companyList.forEach(item => (item.disabled = true));
        this.companyList[0].disabled = false;
        this.menuManagementEditForm.companyIds = this.companyList[0].id;
      } else {
        this.companyList.forEach(item => (item.disabled = false));
      }
    }
  },
  data() {
    return {
      getCompanyId: "",
      isShowOperationLog: false,
      menuIdDelete: "",
      menuName: "",
      modal_loading: false,
      menuDelmodal: false, //删除
      loading: true,
      menuId: "",
      menuIdEdit: "",
      menuManagementEditModal: false, //编辑
      companyList: [{ id: 0, name: "通用" }],
      menuRoleList: [
        {
          id: 0,
          label: 0,
          name: "普通菜单"
        },
        {
          id: 1,
          label: 1,
          name: "付费菜单"
        }
      ],
      menuTypeList: [
        {
          id: 0,
          label: "C",
          name: this.$t("MenuManagement.directory")
        },
        {
          id: 1,
          label: "M",
          name: this.$t("MenuManagement.menu")
        },
        {
          id: 2,
          label: "B",
          name: this.$t("MenuManagement.button")
        }
      ],
      menuManagementEditForm: {
        titleEnglish: "",
        title: "",
        order: "",
        path: "",
        menuType: "",
        component: "",
        icon: "",
        buttonName: "",
        perms: "",
        menuRole: 0,
        companyIds: ""
      },
      ruleValidate: {
        companyIds: [
          {
            required: true,
            message: "请选择公司" // trigger: "change", // type: "array"
          }
        ],
        menuType: [
          {
            required: true,
            message: this.$t("MenuManagement.pleaseSelectType"),
            trigger: "change",
            type: "string"
          }
        ],
        title: [
          {
            required: true,
            message: this.$t("MenuManagement.pleaseInputMenuTitle"),
            trigger: "blur"
          }
        ],
        titleEnglish: [
          {
            required: true,
            message: this.$t("MenuManagement.pleaseInputEnglishTitle"),
            trigger: "blur"
          }
        ],
        order: [
          {
            required: true,
            message: this.$t("MenuManagement.pleaseInputSort"),
            trigger: "blur"
          }
        ],
        path: [
          {
            required: true,
            message: this.$t("MenuManagement.pleaseInputAddressPath"),
            trigger: "blur"
          }
        ],
        component: [
          {
            required: true,
            message: this.$t("MenuManagement.pleaseInputComponentPath"),
            trigger: "blur"
          }
        ],
        icon: [
          {
            required: false,
            message: this.$t("MenuManagement.pleaseInputMenuIcon"),
            trigger: "blur"
          }
        ],
        buttonName: [
          {
            required: true,
            message: this.$t("MenuManagement.pleaseInputButtonName"),
            trigger: "blur"
          }
        ],
        perms: [
          {
            required: true,
            message: this.$t("MenuManagement.pleaseInputPermissionIcon"),
            trigger: "blur"
          }
        ]
      },
      columns: [
        {
          title: this.$t("MenuManagement.menuName"),
          key: "title",
          width: 300,
          tree: true
        },
        {
          title: this.$t("MenuManagement.category"),
          key: "menuType",
          width: 60
        },
        {
          title: this.$t("MenuManagement.sort"),
          key: "order",
          width: 120
        },
        {
          title: this.$t("MenuManagement.category"),
          key: "type",
          width: 150
        },
        {
          title: this.$t("MenuManagement.permissionIcon"),
          key: "perms",
          width: 150
        },
        {
          title: this.$t("MenuManagement.addressPath"),
          key: "path"
        },
        {
          title: this.$t("MenuManagement.componentPath"),
          key: "component"
        },
        {
          title: this.$t("MenuManagement.operation"),
          type: "action",
          actions: [
            {
              type: "success",
              id: "log",
              text: this.$t("alarms.common.operationLog")
            },
            {
              type: "warning",
              id: "edit", // 用于区分编辑和删除，在打印时使用
              text: this.$t("MenuManagement.edit")
            },
            {
              type: "error",
              id: "delete",
              text: this.$t("MenuManagement.delete")
            }
          ],
          width: "150"
        }
      ],
      menuManagementData: [],
      menuData: [],
      selection: []
    };
  },
  beforeCreate: function() {
    tableMenuManagementVue = this;
  },
  mounted: function() {
    // tableMenuManagementVue.getMenuManagementData();
  },
  methods: {
    // 显示不同图标
    renderContent(h, { root, node, data }) {
      if (data.menuType == "B") {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%"
            }
          },
          [
            h("span", [
              h("Icon", {
                props: {
                  type: "ios-radio-button-on"
                },
                style: {
                  marginRight: "8px"
                }
              }),
              h("span", data.title)
            ])
          ]
        );
      } else if (data.menuType == "C") {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%"
            }
          },
          [
            h("span", [
              h("Icon", {
                props: {
                  type: "ios-bookmark"
                },
                style: {
                  marginRight: "8px"
                }
              }),
              h("span", data.title)
            ])
          ]
        );
      } else if (data.menuType == "M") {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%"
            }
          },
          [
            h("span", [
              h("Icon", {
                props: {
                  type: "ios-grid"
                },
                style: {
                  marginRight: "8px"
                }
              }),
              h("span", data.title)
            ])
          ]
        );
      }
    },
    showAll: function() {
      tableMenuManagementVue.getMenuManagementData();
    },
    // 分页显示数据
    getMenuManagementData: function() {
      // 列表分页
      this.$api.menu
        .menuManagement("companyId", this.getCompanyId)
        .then(res => {
          this.menuManagementData = res.data;
        });
    },
    rowClick(row, event, index, text, action) {
      // 删除
      if (action == "delete") {
        this.menuName = row.title;
        this.menuIdDelete = row.menuId;
        this.menuDelmodal = true;
      }
      // 日志
      else if (action == "log") {
        this.logClick(row);
      }
      // 编辑
      else if (action == "edit") {
        this.getCompanyDropDownBox();
        console.log("row", row);
        this.menuIdEdit = row.menuId;
        setTimeout(() => {
          // 类型
          this.menuManagementEditForm.menuType = row.menuType;
          // 上级菜单
          this.menuId = row.parentId;
          // 查询上级菜单
          let a = row.companyIds.toString();
          this.$api.menu
            .menuTreeNode({
              companyId: a,
              menuType: row.menuType
            })
            .then(res => {
              this.menuData = res.data;
              this.menuManagementEditForm.companyIds = row.companyIds;
            });
        }, 1000);
        // 菜单角色
        this.menuManagementEditForm.menuRole = row.menuRole;

        // 按钮名称
        this.menuManagementEditForm.buttonName = row.title;
        // 权限标识
        this.menuManagementEditForm.perms = row.perms;
        // 菜单标题
        this.menuManagementEditForm.title = row.title;
        // 英文标题
        this.menuManagementEditForm.titleEnglish = row.titleEn;
        // 菜单图标
        this.menuManagementEditForm.icon = row.type;
        // 排序
        this.menuManagementEditForm.order = row.order;
        // 地址栏路径
        this.menuManagementEditForm.path = row.path;
        // 组件路径
        this.menuManagementEditForm.component = row.component;
        this.menuManagementEditModal = true;
      }
    },
    /*************************刪除*********************************/
    removeMenu: function() {
      this.$api.menu.menuDelete("menuId", this.menuIdDelete).then(res => {
        this.modal_loading = true;
        setTimeout(() => {
          tableMenuManagementVue.getMenuManagementData();
          this.modal_loading = false;
          this.menuDelmodal = false;
          this.$Message.success("删除成功");
        }, 1000);
      });
    },
    /*************************编辑*********************************/
    // 切换菜单类型
    changeMenuType: function() {
      this.$api.menu
        .menuTreeNode({
          menuType: this.menuManagementEditForm.menuType,
          companyId: this.menuManagementEditForm.companyIds
        })
        .then(res => {
          // 所有菜单数组
          this.menuData = res.data;
        });
    },
    selectAll: function(selection) {
      this.menuId = "";
      this.selection = selection;
      for (var i = 0; i < this.selection.length; i++) {
        this.menuId = this.selection[i].menuId;
      }
    },
    menuManagementEditSubmit: function(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          // 添加
          var menuDTO = {
            menuId: this.menuIdEdit,
            menuType: this.menuManagementEditForm.menuType
          };
          // 目录
          if (this.menuManagementEditForm.menuType == "C") {
            //如果parentId传给后端为空 后端parentId为0
            menuDTO.parentId = this.menuId;
            menuDTO.title = this.menuManagementEditForm.title;
            menuDTO.titleEn = this.menuManagementEditForm.titleEnglish;
            menuDTO.component = this.menuManagementEditForm.component;
            menuDTO.path = this.menuManagementEditForm.path;
            menuDTO.order = this.menuManagementEditForm.order;
            menuDTO.type = this.menuManagementEditForm.icon;
            menuDTO.menuRole = this.menuManagementEditForm.menuRole;
            menuDTO.companyIds = this.menuManagementEditForm.companyIds;
          } else if (this.menuManagementEditForm.menuType == "M") {
            //如果parentId传给后端为空 后端parentId为0
            menuDTO.parentId = this.menuId;
            menuDTO.title = this.menuManagementEditForm.title;
            menuDTO.titleEn = this.menuManagementEditForm.titleEnglish;
            menuDTO.component = this.menuManagementEditForm.component;
            menuDTO.path = this.menuManagementEditForm.path;
            menuDTO.order = this.menuManagementEditForm.order;
            menuDTO.type = this.menuManagementEditForm.icon;
            menuDTO.menuRole = this.menuManagementEditForm.menuRole;
            menuDTO.companyIds = this.menuManagementEditForm.companyIds;
          } else if (this.menuManagementEditForm.menuType == "B") {
            menuDTO.parentId = this.menuId;
            menuDTO.title = this.menuManagementEditForm.buttonName;
            menuDTO.perms = this.menuManagementEditForm.perms;
            menuDTO.menuRole = this.menuManagementEditForm.menuRole;
            menuDTO.companyIds = this.menuManagementEditForm.companyIds;
          }
          if (menuDTO.companyIds == 0) {
            menuDTO.companyIds = [0];
          }
          this.$api.menu.menuUpdate(menuDTO).then(res => {
            setTimeout(() => {
              tableMenuManagementVue.getMenuManagementData();
              this.$refs[name].resetFields();
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
              this.$Message.success("编辑成功");
              this.menuId = "";
              this.selection = [];
              this.menuManagementEditModal = false;
              this.menuManagementEditForm.companyIds = this.companyList[0].id;
            }, 1000);
          });
        } else {
          this.loading = false;
          setTimeout(() => {
            this.loading = true;
          }, 0);
          this.$Message.error("添加失败");
        }
      });
    },
    menuManagementEditReset: function(name) {
      this.menuId = "";
      this.selection = [];
      this.$refs[name].resetFields();
      this.menuData = [];
      this.menuManagementEditForm.companyIds = this.companyList[0].id;
    },
    // 操作日志
    /****************************************************/
    logClick: function(row) {
      this.isShowOperationLog = true;
      this.$nextTick(function() {
        this.$refs.configurationManagementOperationLog.getConfigurationManagementOperationLogList(
          row.id,
          12
        );
      });
    },
    changeCompany() {
      if (this.menuManagementEditForm.companyIds.length == 0) {
        return;
      }
      this.$api.menu
        .menuTreeNode({
          menuType: this.menuManagementEditForm.menuType,
          companyId: this.menuManagementEditForm.companyIds
        })
        .then(res => {
          // 所有菜单数组
          this.menuData = res.data;
        });
    },
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = this.companyList.concat(res.data);
          this.companyList.forEach(element => {
            element.disabled = false;
          });
        });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/menu_management/TableMenuManagement.vue